(function() {
  'use strict';

  function EventSectionViewController(
    $scope,
    $rootScope,
    $translate,
    EventSections,
    EventSection,
    Utils,
    Auth,
    EVENT_STATES
  ) {
    var ctrl = this;

    function loadEvent() {
      // console.log(Date(), 'Starting event loading');
      const prom = ctrl.user
        ? EventSections.findFor(ctrl.eventSectionId, ctrl.user).then(doc => doc.doc)
        : EventSections.find(ctrl.eventSectionId);
      prom.then(function(item) {
        ctrl.eventSection = new EventSection(item);
        $rootScope.$broadcast('KZCurrentEventChange', { event: ctrl.eventSection });
        ctrl.eventSection.init()
          .then(function() {
            return ctrl.eventSection.loadOriginalEvent()
              .then(function() {
                ctrl.eventSection.originalEvent = ctrl.eventSection.loadAdditionalActions(
                  ctrl.eventSection.originalEvent
                );
              });
          })
          .then(function() {
            ctrl.actionButtons = ctrl.eventSection.actionButtons;
            ctrl.actionButtons.push({
              label: $translate.instant('Back'),
              position: 1,
              back: true,
              type: 'link',
              icon: 'icon-left-open-big',
              color: 'primary'
            });
            // Commenting are disabled for merged section untill we decide
            // what to do with revalidation
            ctrl.commentAllowed = ctrl.eventSection.doc.state !== 'merged';
            var pageEventTitle = ctrl.eventSection.eventType
              ? ctrl.eventSection.eventType.name
              : 'draft';
            Utils.setPageTitle('View ' + pageEventTitle);
            ctrl.authorized = true;
            ctrl.loaded = true;
          })
          .catch(function(error) {
            if (error && error.status && error.status === 403) {
              Utils.unauthorized(error);
              return;
            }

            Utils.showError(error);
          });
      });
    }

    ctrl.$onInit = function() {
      ctrl.EVENT_STATES = EVENT_STATES;
      ctrl.extraIsExpanded = ctrl.scrollTo === 'tags' ||
                              ctrl.scrollTo === 'documents';

      ctrl.username = ctrl.user || Auth.currentUser();
      ctrl.auditLogShown = false;


      // We have to broadcast the formControll only when initialized and it's done only after
      // the form element (directive) is processed
      // $scope.$watch('eventCtrl.form', function(form) {
      //   if (form !== undefined) {
      //     $rootScope.$broadcast('KZCurrentFormChange', { form: form });
      //   }
      // });

      // If action is edit and we don't have state params redirect back
      if (!ctrl.eventSectionId) {
        Utils.go(['/events/list'], { tryBack: true });
      } else {
        loadEvent(ctrl.eventSectionId);
      }
    };

    $scope.$on('KZItemRemoved', function() {
      if (ctrl.username === ctrl.event.doc.user) {
        Utils.go(['/events/list'], { tryBack: true });
      } else {
        return Utils.go(['/users/edit', ctrl.username, 'events'], { tryBack: true });
      }
    });

    $scope.$on('EventReload', function(_evt, args) {
      if (ctrl.eventSection.doc !== undefined && args.id === ctrl.eventSection.doc._id) {
        ctrl.updateEvent();
      }
    });

    ctrl.updateEvent = function() {
      console.log('Reloading event');
      return ctrl.eventSection.reload()
        .then(function() {
          loadEvent();
        });
    };
  }

  EventSectionViewController.$inject = [
    '$scope',
    '$rootScope',
    '$translate',
    'EventSectionsService',
    'EventSectionFactory',
    'UtilsService',
    'AuthService',
    'EVENT_STATES'


  ];

  angular.module('component.events')
    .component('eventSectionViewComponent', {
      templateUrl: 'app/components/events/eventsection.view.html',
      controller: EventSectionViewController,
      controllerAs: 'eventViewCtrl',
      bindings: {
        eventSectionId: '<',
        eventSection: '<',
        scrollTo: '<',
        user: '<'
      }
    });
})();
